// ets_tracing: off
import * as R from "@effect-ts/core/Collections/Immutable/Dictionary";
import { pipe } from "@effect-ts/core/Function";
import * as T from "@effect-ts/core/Sync";
import { isUnknownRecord } from "../../Guard/interpreter/common.mjs";
import { interpreter } from "../../HKT/index.mjs";
import { projectFieldWithEnv2 } from "../../Utils/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { appendContext, fail, makeDecoder } from "../common/index.mjs";
import { forEachRecordWithIndex, mergePrefer, originalSort, tuple } from "./common.mjs";
export const decoderObjectInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  interface: (props, cfg) => env => (decoder => {
    const keys = Object.keys(decoder);
    return new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(interfaceDecoder(keys, decoder, cfg === null || cfg === void 0 ? void 0 : cfg.name), env, {
      decoder: R.map_(decoder, d => d.decoder)
    })).setChilds(decoder);
  })(projectFieldWithEnv2(props, env)),
  partial: (props, cfg) => env => (decoder => {
    return new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(partialDecoder(decoder, cfg === null || cfg === void 0 ? void 0 : cfg.name), env, {
      decoder: R.map_(decoder, d => d.decoder)
    })).setChilds(decoder);
  })(projectFieldWithEnv2(props, env)),
  both: (props, partial, cfg) => env => (decoder => (decoderPartial => {
    const keys = Object.keys(decoder);
    return new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => T.map_(tuple(interfaceDecoder(keys, decoder, cfg === null || cfg === void 0 ? void 0 : cfg.name).validate(u, c), partialDecoder(decoderPartial, cfg === null || cfg === void 0 ? void 0 : cfg.name).validate(u, c)), ([r, o]) => originalSort(u, mergePrefer(u, r, o))), "both", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "Both"), env, {
      decoder: R.map_(decoder, d => d.decoder),
      decoderPartial: R.map_(decoderPartial, d => d.decoder)
    })).setChilds({ ...decoder,
      ...decoderPartial
    });
  })(projectFieldWithEnv2(partial, env)))(projectFieldWithEnv2(props, env))
}));

function partialDecoder(decoder, name) {
  return makeDecoder((u, c) => {
    if (isUnknownRecord(u)) {
      return forEachRecordWithIndex((k, a) => typeof a !== "undefined" && decoder[k] ? decoder[k].decoder.validate(a, appendContext(c, k, decoder[k].decoder, a)) : T.succeed(a))(u);
    }

    return fail(u, c, `${typeof u} is not a record`);
  }, "partial", name || "Partial");
}

function interfaceDecoder(keys, decoder, name) {
  return makeDecoder((u, c) => {
    if (isUnknownRecord(u)) {
      const set = new Set(keys.concat(Object.keys(u)));
      const r = {};
      set.forEach(k => {
        r[k] = u[k];
      });
      return forEachRecordWithIndex((k, a) => decoder[k] ? decoder[k].decoder.validate(a, appendContext(c, k, decoder[k].decoder, a)) : T.succeed(a))(r);
    }

    return fail(u, c, `${typeof u} is not a record`);
  }, "interface", name || "Interface");
}
//# sourceMappingURL=object.mjs.map